import {FC, useState} from 'react'
import {Button, FloatingLabel, Form, Spinner} from 'react-bootstrap'
import {useTranslation} from 'react-i18next'
import i18next from 'i18next'
import {CustomModal} from './../../../components/CustomModal'
import {getChatOrder, postChatOrder} from '../../../api/modules/order'
import swal from 'sweetalert'
import {parse, format, parseISO} from 'date-fns'
import {ActionIcon} from 'src/components'
interface ChatButtonProps {
  id?: number
  flag?: string
}

export const ChatButton: FC<ChatButtonProps> = ({id, flag, ...props}) => {
  const {t} = useTranslation()
  const [openModal, setOpenModal] = useState(false)
  const [fullChat, setFullChat] = useState<any>([])
  const [tempChat, setTempChat] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  const handleGetChat = async () => {
    setIsLoading(true)
    await getChatOrder(id, flag)
      .then((res: any) => {
        setFullChat(res.data.data)
        setOpenModal(true)
      })
      .finally(() => setIsLoading(false))
  }

  const handlePostChat = async () => {
    setIsLoading(true)
    await postChatOrder(
      i18next.language,
      {
        parent_id: id,
        user_id: localStorage.getItem('user-id'),
        comment: tempChat,
        credentials: localStorage.getItem('credential'),
      },
      flag
    )
      .then((res) => {
        swal({
          title: `${t('Chat Berhasil Ditambahkan')}`,
          icon: 'success',
        }).then(() => {
          handleGetChat()
          setTempChat('')
          const areacomment = document.getElementById('areachat') as HTMLInputElement
          if (areacomment != null) areacomment.value = ''
        })
      })
      .catch((error) => {
        swal({
          title: t(error.response.data.message),
          icon: 'error',
        })
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  const handleClick = (data: any) => {
    try{
      const parsedDate = parseISO(data)
      const formattedTime = format(parsedDate, 'dd MMM yyyy, HH:mm')
      return formattedTime
    }catch(e: any){
      return "-"
    }
  }

  return (
    <>
      <ActionIcon
        className='me-1'
        title={t('Chat')}
        iconPath='/media/icons/duotune/chat-dots-fill.svg'
        isLoading={isLoading}
        disabled={isLoading}
        onClick={handleGetChat}
      />

      <CustomModal
        title={t('Chat')}
        show={openModal}
        size='lg'
        onHide={() => {
          setOpenModal(false)
        }}
        centered
      >
        <FloatingLabel controlId='floatingTextarea2' label={t('Chat')}>
          <Form.Control
            as='textarea'
            id='areachat'
            placeholder={t('Tinggal-pesan')}
            style={{height: '100px'}}
            onChange={(e: any) => setTempChat(e.target.value)}
          />
        </FloatingLabel>
        <div className='d-flex justify-content-end'>
          <Button variant='primary' className='mt-3 mb-3' onClick={() => handlePostChat()}>
            {t('Tambah')}
          </Button>
        </div>
        {fullChat?.length < 1 ? (
          ''
        ) : (
          <div className='table-responsive mt-10 bdr'>
            <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
              <thead>
                <tr className='fw-bold w-100 align-items-center'>
                  <th className='td-3 text-center px-0' style={{width: 70}}>
                    {t('no')}
                  </th>
                  <th className='td-3 text-center'>{t('order-tanggal')}</th>
                  {/* <th className='td-3 text-center'>{t('User Code')}</th> */}
                  <th className='td-3 text-center'>{t('order-user')}</th>
                  <th className='td-3 text-center'>{t('Chat')}</th>
                </tr>
              </thead>
              {fullChat?.map((item: any, _index: number) => (
                <tbody key={item?.customer_code ?? _index}>
                  <tr className='w-100 align-items-center'>
                    <td className='text-center' style={{width: 70}}>
                      {_index + 1}
                    </td>
                    <td className='td-150 text-center'>{handleClick(item.created_at)}</td>
                    {/* <td className='td-150 text-center'>
                      {item.user?.customer_code || item.user?.nama_pengguna}
                    </td> */}
                    <td className='td-150 text-center'>{item.user?.name}</td>
                    <td className='td-60 text-center'>
                      <div style={{textAlign: 'justify', padding: '0 0.775rem'}}>
                        {item.comment}
                      </div>
                    </td>
                  </tr>
                </tbody>
              ))}
            </table>
          </div>
        )}
      </CustomModal>
    </>
  )
}

ChatButton.defaultProps = {
  flag: 'order_submission',
}
